// Imperative, local player clock: avoid rebuilding thousands of map features
// or rerendering the dispatch application on video timeupdate events.
const listeners = new Set<(id: string, time: number | null) => void>();
export function emitPlaybackTime(id: string, time: number | null) { for (const listener of listeners) listener(id, time); }
export function subscribePlaybackTime(listener: (id: string, time: number | null) => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
